/* created on: 24.01.2019 by: Davor
*  updated on: ...
* ajaxForm.init("ITEM", [72866], {target:"#region_right"});
*/
var ajaxForm = {
    ajaxCode: null,
    params: null,
    options: null,
    genData: [],
    data: [],
    dataIndex: [],
    btnData: [],
    updated: false,
    html: null,
    init: function (pCode, pParams, pOptions) {
        let dataOnly = (pCode == this.ajaxCode && this.params.length == pParams.length);
        this.ajaxCode = pCode;
        this.params = pParams;
        this.options = pOptions;
        this.updated = false;
        this.loadData(dataOnly);
    },
    loadData: function (pDataOnly) {
        var self = this, vDataOnly = (pDataOnly) ? "Y" : "N";
        vms.page.loading();
        $.ajax({
            url: "wwv_flow.show",
            dataType: "json",
            traditional: true,
            cache: false,
            type: "GET",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=ajaxForm",
                x01: self.ajaxCode,
                x02: vDataOnly,
                f01: self.params
            },
            success: function (d) {
                vms.page.loadingRemove();
                if (d.ERR) alert(d.ERR);
                else {
                    self.setData(d.data);
                    if (d.btnData) self.btnData = d.btnData;
                    else self.btnData = [];
                    if (!pDataOnly) self.genData = d.genData;
                    self.updated = false;
                    self.render();
                }
            }
        });
    },
    setData: function (data) {
        // set data
        this.data = data;
        // make data array with id names
        this.dataIndex = this.data.map(e => e.id);
    },
    getDataById: function (pId) {
        return this.data[this.dataIndex.indexOf(pId)];
    },
    render: function () {
        this.html = "";
        var lButtons = [];
        for (var i = 0; i < this.genData.buttons.length; i++) {
            switch (this.genData.buttons[i].type) {
                case "create": lButtons.push({"id":"ajaxC","label":"Create","fa":"far fawe-plus","js":"ajaxForm.submit(\'C\')"});
                    break;
                case "save": lButtons.push({"id":"ajaxU","label":"Apply Changes","fa":"fas fawe-save","js":"ajaxForm.submit(\'U\')"});
                    break;
                case "delete": lButtons.push({"id":"ajaxU","label":"Delete","fa":"fas fawe-trash-alt","js":"ajaxForm.submit(\'D\')"});
                    break;
                case "custom": lButtons.push({"id":"ajaxU","label":this.genData.buttons[i].text,"fa":"fas fawe-trash-alt","js":this.genData.buttons[i].link});
                    break;
                /*case "btnData": var btnIndex = this.btnData.map(e => e.id).indexOf(this.genData.buttons[i].id);
                    lButtons.push({"id":this.btnData[btnIndex].id,"label":this.btnData[btnIndex].text,"fa":"fas fawe-trash-alt","js":this.btnData[btnIndex].link});
                    break;*/
                default: null;
            }
        }
        for (var i = 0; i < this.btnData.length; i++) {
            lButtons.push(this.btnData[i]);
        }
        // Generate Items
        for (var i = 0; i < this.genData.items.length; i++) {
            // new row
            //if (this.genData.items[i].newRow == 'Y') this.html += '<br>';
            // gen item (fetch data for item based on the item id)
            this.html += genItem(this.genData.items[i], this.getDataById(this.genData.items[i].id));
        }
        this.html = '<section id="ajaxForm-' + self.ajaxCode + '" class="col col-12 apex-col-auto ajaxForm" onchange="ajaxForm.updated = true;">'
            + '<header><h1>' + this.genData.title + '</h1><div class="ajaxForm__btnContainer">'
            + vms.btn.genAll(lButtons)
            + '</div></header><div class="ajaxForm__main">'
            + this.html
            + '</div></section>';
        if (this.options.target) {
            $(this.options.target).html(this.html).show();
        }
        initItems();
        $("#ajaxForm-"+ self.ajaxCode + " .ajaxForm__main").on("change", () => {vms.btn.hightlight("ajaxU");vms.btn.hightlight("ajaxC");} );
    },
    close: function () {
        this.data = null;
        $(this.options.target).hide();
    },
    submit: function (pAction) {
        var self = this;
        var lItems = [];
        var lData = [];
        //if (self.changed){
        for (var i = 0; i < this.genData.items.length; i++) {
            var lValue = getItemVal(self.genData.items[i]);
            //if (lValue){
            lData.push(lValue);//.replace("~","")
            lItems.push(self.genData.items[i].id);
            //}
        }
        vms.page.loading();
        apex.server.process("ajaxFormSubmit", {
            "x01": self.ajaxCode,
            "x02": pAction,
            "f01": self.params,
            "f02": lItems,
            "f03": lData
        }, {
                dataType: "json",
                success: function (d) {
                    apex.message.clearErrors();
                    if (d.msg) {
                        /*if (self.data.gen.open == "popUp") alert(d.msg);
                        else */
                        apex.message.showErrors([{ type: "error", location: ["page"], message: d.msg, unsafe: false }]);
                        //alert(d.msg);
                    }
                    if (d.err) {
                        /*if (self.data.gen.open == "popUp") alert(d.err);
                        else*/
                        apex.message.showErrors([{ type: "error", location: ["page"], message: d.err, unsafe: false }]);
                        //alert(d.err);
                    } else if (pAction == "D") {
                        self.updated = false;
                        self.refreshParent(pAction);
                        self.close();
                    } else {
                        self.updated = false;
                        // reset parameters
                        self.params = d.params.split(":");
                        // set general data
                        if (pAction == "C") self.genData = d.genData;
                        // refresh buttons
                        if (d.btnData) self.btnData = d.btnData;
                        else self.btnData = [];
                        // set Data
                        self.setData(d.data);
                        // render form
                        self.render();
                        // display success msg
                        if (!d.msg) {
                            if (self.options.target) apex.message.showPageSuccess("Changes saved.");
                        }
                        self.refreshParent(pAction);
                    }
                    vsmLoadRemove();
                }
            });
    },
    refreshParent: function (pAction) {
        switch (this.ajaxCode) {
            case "ITEM":
                $s("P369_ID", this.params[0]);
                var vBarcode = this.getDataById("cpc_barcode").r;
                updateEqTree({
                    action: pAction,
                    id: this.params[0],
                    parent: this.getDataById("cpc_parent_id").r,
                    label: (vBarcode ? vBarcode + " | " : "") + this.getDataById("cpc_name").r
                });
                if (pAction == "C"){
                    $("#itemTabs").show();
                    apex.region("pgIR1").refresh();
                    apex.region("pgIR2").refresh();
                    apex.region("pgIR3").refresh();
                    apex.region("pgIR4").refresh();
                }
                //$.event.trigger("refreshTree");
                break;
            case "ITEM_ALL":
                apex.event.trigger( "#itemIR", "apexrefresh" );
                break;
            default: break;
        }
    },
    getLovIndex: function (pLovId) {
        for (var i = 0; i < this.genData.lov.length; i += 1) {
            if (this.genData.lov[i].id == pLovId) {
                return i;
            }
        }
        return -1;
    }
}